if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.sizeInputs = document.querySelectorAll('[name="Size"]') || document.querySelectorAll('[name="مقاس"]');
      this.recipientFields = document.querySelectorAll('.recipient-fields');

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      if (this.recipientFields) {
        Array.from(this.recipientFields).forEach((recipientField) => {
          const input = recipientField.querySelector('input') || recipientField.querySelector('textarea');
          input.addEventListener('focus', () => {
            recipientField.classList.remove('error');
          })
        })
      }
      if (this.sizeInputs) {
        Array.from(this.sizeInputs).forEach((input) => {
          const isChecked = input.checked;
          const isAvailable = this.variantIsAvailable(input);
          if (isChecked && !isAvailable) {
            this.onUnavailableVariantSelected();
          }
          input.addEventListener('change', this.onVariantSelect.bind(this));
        });
      }
    }

    onUnavailableVariantSelected() {
      const event = new CustomEvent(window.FarmRio.events.selectedUnavailableVariant);
      document.dispatchEvent(event);
    }

    variantIsAvailable(input) {
      const availableQuantity = parseInt(input.dataset.availablequantity);
      return availableQuantity > 0;
    }

    onVariantSelect(event) {
      const isAvailable = this.variantIsAvailable(event.target);
      if (!isAvailable) this.onUnavailableVariantSelected();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      document.dispatchEvent(new Event('cartAdd'));
      let submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      if (submitButton.classList.contains('button--secondary')) {
        const variantId = submitButton.dataset.variantId;
        const backInStock = document.querySelector('back-in-stock');

        backInStock.setVariantId(+variantId);
        backInStock.openModal(evt);

        return;
      }

      if (evt.target.closest('.is-float')) {
        document.dispatchEvent(new Event(window.FarmRio.events.addProductToCartFromFloatInformation));
      }

      this.handleErrorMessage();
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      const isNewCart = !Boolean(window.getCookie("cart"));

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (isNewCart && window.FarmRio.events.createCart) {
            document.dispatchEvent(new Event(window.FarmRio.events.createCart))
          }
          if (response.status) {
            this.handleErrorMessage(response.description);
          } else {
            return fetch(`${window.routes.root_url}/cart.js`, { credentials: 'same-origin' });
          }
        })
        .then((response) => {
          if (!response.ok) throw Error;
          return response.json();
        })
        .then((data) => {
          const cartUpdateEvent = new CustomEvent('cartUpdate', { detail: data });
          const id = this.querySelector('#product-form-selected-sku')?.value;
          const el = id ? document.querySelector(`[data-json-sku="${id}"]`) : null;
          const eventData = el ? JSON.parse(el.innerHTML) : null;

          if (window.FarmRio.events.addProductToCart) {
            const title = eventData?.name;
            const eventName = window.FarmRio.events.addProductToCart;
            const event = new CustomEvent(eventName, { detail: { title } });
            document.dispatchEvent(event);
          }

          if (data.items.length) {
            const klaviyoObj = {
              total_price: data.total_price / 100,
              $value: data.total_price / 100,
              total_discount: data.total_discount,
              original_total_price: data.original_total_price / 100,
              items: data.items
            }
            window._learnq = window._learnq || [];
            window._learnq.push(['track', 'Added to Cart', klaviyoObj]);
          }

          document.dispatchEvent(cartUpdateEvent);
          document.getElementById('cart-icon-bubble').click();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      const handleFieldErrorMessage = (message, field) => {
        if (!message || !field) return;
        const $wrapper = this.form.querySelector(`.recipient-fields__field.${field}`);
        if (!$wrapper) return;
        $wrapper.classList.add('error');
        const $errorWrapper = $wrapper.querySelector(`.form__message`);
        if (!$errorWrapper) return;
        $errorWrapper.classList.remove('hidden');
        const $errorMessageElement = $errorWrapper.querySelector('.error-message');
        if (!$errorMessageElement) return;
        $errorMessageElement.innerHTML = message;
      }

      if (typeof errorMessage === "string") {
        this.errorMessage.textContent = errorMessage
      }

      if (errorMessage && typeof errorMessage === "object" && !Array.isArray(errorMessage)) {
        const fields = Object.keys(errorMessage);

        const generalError = fields.reduce((acc, key) => {
          const fieldErrorMessage = errorMessage[key].join('. ');
          const specificErrorFields = ['send_on', 'email'];
          if (specificErrorFields.includes(key)) {
            handleFieldErrorMessage(fieldErrorMessage, key);
            return acc;
          } else {
            return acc.concat(fieldErrorMessage);
          }
        }, "");

        if (generalError) {
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          this.errorMessage.textContent = generalError;
        }
      }
    }
  });
}
